<template>
  <v-container class="p-pay">
    <v-layout>
      <Stepper :value="2"></Stepper>
    </v-layout>
    <v-layout class="mt-2">
      <v-flex grow>
        <CSection title="支付保费">
          <v-layout>
            <v-flex>
              <h3 class="my-3">{{ order.productName || order.productSeriesName }}</h3>
              <p class="introduce-text mb-1">保障期限 {{ startDate }} 至 {{ endDate }} 共 {{ duration }}</p>
              <p class="introduce-text">投保员工共 {{ order.insureds }} 人</p>
            </v-flex>
            <v-flex shrink class="ml-5">
              <v-layout align-center justify-end fill-height>
                <span class="introduce-text mt-2 mr-2">总保费：</span>
                <span class="display-1 primary-text">￥{{ order.amounts }}</span>
              </v-layout>
            </v-flex>
          </v-layout>
        </CSection>
      </v-flex>
    </v-layout>

    <v-layout class="mt-4">
      <v-flex grow>
        <CSection>
          <p class="size2">请选择支付方式</p>
          <v-divider></v-divider>
          <h3 class="mt-4 mb-3">支付平台</h3>
          <v-layout class="group">
            <v-flex
              v-for="(item,index) in platforms"
              :key="item.value"
              class="group-item mr-4"
              @click="selectedPlatform = index"
            >
              <img :src="item.img" class="group-item-img">
              <img
                v-if="index === selectedPlatform"
                class="group-item-checked"
                src="https://qihuibao.oss-cn-beijing.aliyuncs.com/pay/box-checked.png"
              >
            </v-flex>
          </v-layout>
        </CSection>
      </v-flex>
    </v-layout>

    <v-layout class="mt-4">
      <v-btn class="pay-btn mt-3" :loading="loading" color="primary" large @click="pay">立即支付</v-btn>
      <form ref="form" :action="platforms[selectedPlatform].action" method="post" class="d-none">
        <input :value="order.insurerProposalNo" type="hidden" name="orderCoder">
        // 支付类型 1 易宝支付PC 2 支付宝支付（团意险除外）3 易宝手机支付4 微信支付（团意险除外）
        <input
          :value="platforms[selectedPlatform].value"
          type="hidden"
          name="payType"
        >
        <input :value="order.amounts" type="hidden" name="payAmt">
        // 业务类型 1：车险；0：非车险
        <input :value="0" type="hidden" name="vhlType">
        // 前端回调地址
        <input :value="resultUrl" type="hidden" name="foreEndURL">
        // 组合险标志号
        <input value type="hidden" name="combinationNo">
        // 批改支付号
        <input value type="hidden" name="randomno">
      </form>
    </v-layout>
  </v-container>
</template>

<script>
import Stepper from "../insure/components/Stepper";
import dateUtil from "@/assets/js/utils/date.js";
export default {
  components: {
    Stepper
  },
  props: {
    orderCode: String
  },
  data() {
    return {
      loading: false,
      selectedPlatform: 0, // 选中的 platforms 索引
      platforms: [
        {
          img:
            "https://qihuibao.oss-cn-beijing.aliyuncs.com/company/pay/yeepay.png",
          text: "易宝支付PC",
          value: "1",
          action: process.env.VUE_APP_YeePay_URL
        }
      ],
      order: {
        orderCode: "",
        userId: "",
        insurerProposalNo: "", // 支付流水号
        productName: "",
        insureStartDate: "",
        insureEndDate: "",
        insureds: 0,
        amounts: 0
      },
      resultUrl: ""
    };
  },
  computed: {
    startDate() {
      return this.$miment(this.order.insureStartDate).format("YYYY-MM-DD");
    },
    endDate() {
      return this.$miment(this.order.insureEndDate).format("YYYY-MM-DD");
    },
    duration() {
      return dateUtil.getDuration(this.startDate, this.endDate);
    }
  },
  created() {
    this.$axios
      .get(`/app/api/gadd/queryPolicy?orderCode=${this.orderCode}`)
      .then(res => {
        this.order = res.data;
      });
  },
  mounted() {
    this.resultUrl = location.origin + "/result";
  },
  methods: {
    pay() {
      if (!this.order || !this.order.orderCode) {
        this.$message.error("操作异常，请退出重试");
        return false;
      }
      this.loading = true;
      // 保存支付请求
      const data = {
        orderCode: this.orderCode,
        payTypeId: this.platforms[this.selectedPlatform].value,
        payAmount: this.order.amounts
      };
      this.$axios
        .post("/app/api/gadd/savePay", data)
        .then(() => {
          this.$refs.form.submit();
        })
        .catch(() => {
          this.$refs.form.submit();
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/var";
.p-pay {
  .group {
    &-item {
      width: 225px;
      height: 57px;
      border: 1px solid $primary-color;
      flex: none;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      cursor: pointer;
      &-img {
        width: 126px;
        height: 45px;
      }
      &-checked {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 24px;
      }
    }
  }
  .pay-btn{
    width: 240px;
    height: 50px;
    margin-left: 0;
  }
}
</style>

